import type {DiffLineKey, DiffLineSelectionInfo, FileKey, LineKey} from '../types'
import {useDiffStore} from './DiffStore'

// State selectors
export const useGetSplitDiffLinesFromLineRange = () => useDiffStore(s => s.diffLines.getSplitDiffLinesFromLineRange)

export const useGetSelectedDiffLines = () => useDiffStore(s => s.diffLines.getSelectedDiffLines)

export const useGetDiffLinesInfo = () => useDiffStore(s => s.diffLines.getDiffLinesInfo)

export const useGetFirstLineSelectionOnDrag = () => useDiffStore(s => s.diffLines.getfirstLineSelectionOnDrag)

export const useGetSelectedLineRange = () => useDiffStore(s => s.diffLines.getSelectedLineRange)

export const useGetIsDraggingFromAddCommentButton = () =>
  useDiffStore(s => s.diffLines.getIsDraggingFromAddCommentButton)

export const useHasSelectedLines = () => useDiffStore(s => s.diffLines.hasSelectedLines)

export const useHiddenFeatures = () => useDiffStore(s => s.hiddenFeatures)

export const useDialogModeIsEnabled = (gridCellId: string | undefined) =>
  useDiffStore(s => {
    if (!gridCellId) return false
    return s.dialogMode.activeGridCellId === gridCellId
  })

export const useDialogModeActions = () => useDiffStore(s => s.dialogModeActions)

export const useDiffAnchor = () => useDiffStore(s => s.diffLines.diffAnchor)

export const useFileLineCount = () => useDiffStore(s => s.diffLines.fileLineCount)

const UNSELECTED_LINE: DiffLineSelectionInfo = {
  isSelected: false,
  isFirstSelected: false,
  isLastSelected: false,
}

export const useDiffLineSelectionInfo = (lineKey: DiffLineKey | undefined | null) =>
  useDiffStore(s => {
    if (!lineKey) return UNSELECTED_LINE
    return s.diffLines.selectedLinesInfo[lineKey] || UNSELECTED_LINE
  })

// Actions selectors
export const useDiffLinesActions = () => useDiffStore(s => s.diffLinesActions)

export const useInjectedContextLinesActions = () => useDiffStore(s => s.injectedContextLinesActions)

export const useTreeEntries = () => useDiffStore(s => s.treeEntries)

export const useGetStartNewCommentOnLine = () => useDiffStore(s => s.getMoveNewCommentDataForLine)
export const useAddStartNewCommentOnLine = () => useDiffStore(s => s.addStartNewCommentOnLine)
export const useStoredCommentAtPosition = (lineMarkersKey: LineKey | FileKey) =>
  useDiffStore(s => s.storedCommentsMap[lineMarkersKey])

export const useGetUpdatePersistedComment = () => useDiffStore(s => s.updateStoredCommentOnLine)

export const useAllSelectedLinesAreRetargetable = () => useDiffStore(s => s.diffLines.allSelectedLinesAreRetargetable)

export const useHideDiffLineActionBar = () => useDiffStore(s => s.hideActionBar)
export const useHideDiffLineAllActionBars = () => useDiffStore(s => s.hideAllActionBars)
export const useShowDiffLineActionBar = () => useDiffStore(s => s.showActionBar)
export const useSetFocusedDiffLineActionBar = () => useDiffStore(s => s.setFocusedActionBar)
export const useClearFocusedDiffLineActionBar = () => useDiffStore(s => s.clearFocusedActionBar)

export const useIsDiffLineActionBarVisible = (cellId: string | undefined) =>
  useDiffStore(s => {
    if (!cellId) return false
    // Prioritize focused cell over hovered cell
    const focusedCellId = s.actionBarVisibility.focusedActionBarCellId
    if (focusedCellId === cellId) {
      return true
    }
    return s.actionBarVisibility.activeActionBarCellId === cellId
  })
